import { render, staticRenderFns } from "./fourMedicine.vue?vue&type=template&id=734dcc26&scoped=true"
import script from "./fourMedicine.vue?vue&type=script&lang=ts"
export * from "./fourMedicine.vue?vue&type=script&lang=ts"
import style0 from "./fourMedicine.vue?vue&type=style&index=0&id=734dcc26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734dcc26",
  null
  
)

export default component.exports